import { memo } from 'react'
import { ITagListProps, ITag } from './types'
import * as Styled from './styled'

const TagList: React.FC<ITagListProps> = ({ tags }) => {
  if (!tags.length) return null

  return (
    <Styled.TagsContainer>
      {tags.map((tag: ITag) => (
        <Styled.TagItem key={tag.id} type="h4" color="secondaryDark">
          {tag.name}
        </Styled.TagItem>
      ))}
    </Styled.TagsContainer>
  )
}

export default memo(TagList)
